import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import Icon from 'flarum/common/components/Icon';
import Stream from 'flarum/common/utils/Stream';
import extractText from 'flarum/common/utils/extractText';
import { field, visPicker, section } from './Field';
import PhotoCropper from './PhotoCropper';
import { VISIBILITY, LANGUAGE_FLAG, COUNTRY_MAX, MANUAL, TIMEZONES, PORTAL_TIMEZONE, COUNTRY_TIMEZONE, countryKey, checkCountry, languages, pickTimezone, timezoneLabel, LOCATION_MAX, BIO_MAX, AGE_MIN, AGE_MAX, countryOptions, languageName, flagUrl, browserTimezone, age, checkBirthdate } from '../utils/infoRules';
const t = (key, params) => app.translator.trans('ppk2-profile.forum.info.' + key, params);
const lib = (key, params) => app.translator.trans('ppk2-profile.lib.photo.' + key, params);
export const MAX_PHOTOS = 3;
export const MAX_BYTES = 2 * 1024 * 1024;

/** attribute -> default (as stored by the server) */
const TEXT = ['ppk2Country', 'ppk2Location', 'ppk2Timezone', 'ppk2Language', 'ppk2Birthdate', 'ppk2Bio'];
const VIS = {
  ppk2CountryVisibility: 'everyone',
  ppk2LocationVisibility: 'everyone',
  ppk2TimezoneVisibility: 'everyone',
  ppk2LanguageVisibility: 'everyone',
  ppk2BirthdateVisibility: 'members',
  ppk2BioVisibility: 'everyone'
};
const BOOL = {
  ppk2TranslateMessages: false,
  ppk2ShowAgeOnly: true,
  ppk2PhotosForRecords: false,
  ppk2ShowPhotos: true
};
export function infoState(user) {
  const initial = {};
  TEXT.forEach(a => initial[a] = user.attribute(a) || '');
  Object.keys(VIS).forEach(a => initial[a] = user.attribute(a) || VIS[a]);
  Object.keys(BOOL).forEach(a => {
    const v = user.attribute(a);
    initial[a] = v === undefined || v === null ? BOOL[a] : !!v;
  });

  // «Язык общения»: a saved language whose pack is not installed is shown as empty.
  if (initial.ppk2Language && !languages()[initial.ppk2Language]) initial.ppk2Language = '';
  // «Страна»: list key (also a list name typed earlier) -> selected; other text -> «…ввести вручную».
  const key = countryKey(initial.ppk2Country);
  if (key) initial.ppk2Country = key;
  const s = {
    initial,
    values: {},
    photos: user.attribute('ppk2Photos') || [],
    showErrors: false,
    uploading: false,
    crop: null
  };
  Object.keys(initial).forEach(a => s.values[a] = Stream(initial[a]));
  // An empty time zone is pre-filled from the browser (saved with the next «Сохранить»).
  s.countryChoice = Stream(key || (initial.ppk2Country ? MANUAL : ''));
  s.countryText = Stream(key ? '' : initial.ppk2Country);
  // Time zone: one of the 11 listed. Empty -> from the browser (nearest row, else Helsinki);
  // a saved zone outside the list -> nearest row. Saved with the next «Сохранить».
  const tz = pickTimezone(initial.ppk2Timezone || browserTimezone());
  if (tz !== initial.ppk2Timezone) {
    s.autoTimezone = tz;
    s.values.ppk2Timezone(tz);
  }
  return s;
}

/** Only changed attributes; empty text -> null. */
export function infoPayload(s) {
  const data = {};
  Object.keys(s.initial).forEach(a => {
    let v = s.values[a]();
    if (typeof v === 'string') v = a === 'ppk2Bio' ? v.trim() : v.trim();
    if (v === s.initial[a]) return;
    data[a] = typeof v === 'string' ? v || null : v;
  });
  return data;
}

/** [key, params] or null */
export function infoLocalError(s) {
  if (s.countryChoice() === MANUAL) {
    const c = checkCountry(s.countryText());
    if (c) return c;
  }
  if (s.values.ppk2Location().trim().length > LOCATION_MAX) return ['ppk2-profile.lib.info.location_too_long', {
    max: LOCATION_MAX
  }];
  if (s.values.ppk2Bio().trim().length > BIO_MAX) return ['ppk2-profile.lib.info.bio_too_long', {
    max: BIO_MAX
  }];
  return checkBirthdate(s.values.ppk2Birthdate());
}
function visibility(s, attr, loading) {
  const options = {};
  VISIBILITY.forEach(v => options[v] = t('visibility.' + v));
  return visPicker(attr, options, s.values[attr](), v => s.values[attr](v), loading, t('visibility.title'));
}
function flagSelect(name, code, options, value, onchange, loading) {
  const url = flagUrl(code);
  return m("div", {
    className: 'Ppk2FlagSelect' + (url ? ' Ppk2FlagSelect--flag' : '')
  }, url ? m("img", {
    className: "Ppk2FlagSelect-flag",
    src: url,
    alt: ""
  }) : null, m(Select, {
    className: "Ppk2FlagSelect-input",
    name: name,
    options: options,
    value: value,
    disabled: loading,
    onchange: onchange
  }));
}
export default class InfoTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.countries = countryOptions();
  }
  view() {
    const s = this.attrs.state;
    const loading = this.attrs.loading;
    const v = s.values;
    const rows = [section(t('section_about'))];

    // Страна: fixed list + «…ввести вручную»
    const countryOpts = {
      '': t('country.choose')
    };
    this.countries.forEach(([c, name]) => countryOpts[c] = name);
    countryOpts[MANUAL] = t('country.manual');
    const choice = s.countryChoice();
    const countryError = choice === MANUAL ? checkCountry(s.countryText()) : null;
    rows.push(field('country', t('country.label'), [flagSelect('ppk2CountryChoice', choice === MANUAL ? '' : choice, countryOpts, choice, x => {
      s.countryChoice(x);
      v.ppk2Country(x === MANUAL ? s.countryText().trim() : x);
      // only at the moment of choosing; manual entry keeps the zone
      if (COUNTRY_TIMEZONE[x]) v.ppk2Timezone(COUNTRY_TIMEZONE[x]);
    }, loading), choice === MANUAL ? m("input", {
      className: "FormControl Ppk2CountryManual",
      name: "ppk2Country",
      maxlength: COUNTRY_MAX,
      placeholder: t('country.manual_placeholder'),
      value: s.countryText(),
      disabled: loading,
      oncreate: vn => !s.countryText() && vn.dom.focus(),
      oninput: e => {
        s.countryText(e.target.value);
        v.ppk2Country(e.target.value.trim());
      }
    }) : null, countryError ? m("div", {
      className: "Ppk2NickStatus Ppk2NickStatus--invalid"
    }, app.translator.trans(countryError[0], countryError[1])) : null], visibility(s, 'ppk2CountryVisibility', loading), t('country.tip')));

    // Откуда
    rows.push(field('location', t('location.label'), m("input", {
      className: "FormControl",
      name: "ppk2Location",
      maxlength: LOCATION_MAX,
      placeholder: t('location.placeholder'),
      value: v.ppk2Location(),
      disabled: loading,
      oninput: e => v.ppk2Location(e.target.value)
    }), visibility(s, 'ppk2LocationVisibility', loading), t('location.tip')));

    // Часовой пояс: 11 fixed rows
    const tzOpts = {};
    TIMEZONES.forEach(z => tzOpts[z[1]] = timezoneLabel(z));
    rows.push(field('timezone', t('timezone.label'), [m("div", {
      className: "Ppk2FlagSelect Ppk2FlagSelect--icon Ppk2TzSelect",
      title: tzOpts[v.ppk2Timezone()] || ''
    }, m(Icon, {
      name: "fas fa-globe",
      className: "Ppk2FlagSelect-icon"
    }), m(Select, {
      className: "Ppk2FlagSelect-input",
      name: "ppk2Timezone",
      options: tzOpts,
      value: v.ppk2Timezone(),
      disabled: loading,
      onchange: x => v.ppk2Timezone(x)
    })), v.ppk2Timezone() === PORTAL_TIMEZONE ? m("div", {
      className: "Ppk2Muted Ppk2TzNote"
    }, m(Icon, {
      name: "fas fa-star"
    }), " ", t('timezone.portal_note')) : null], visibility(s, 'ppk2TimezoneVisibility', loading), t('timezone.tip')));

    // Язык общения
    const langOpts = {
      '': t('language.choose')
    };
    Object.keys(languages()).forEach(l => langOpts[l] = languageName(l));
    const lang = v.ppk2Language();
    rows.push(field('language', t('language.label'), [flagSelect('ppk2Language', LANGUAGE_FLAG[lang], langOpts, lang, x => v.ppk2Language(x), loading), m("label", {
      className: 'Ppk2Check' + (lang ? '' : ' disabled')
    }, m("input", {
      type: "checkbox",
      name: "ppk2TranslateMessages",
      checked: v.ppk2TranslateMessages(),
      disabled: loading || !lang,
      onchange: e => v.ppk2TranslateMessages(e.target.checked)
    }), m("span", null, lang ? t('language.translate', {
      language: languageName(lang, false)
    }) : t('language.translate_empty')))], visibility(s, 'ppk2LanguageVisibility', loading), t('language.tip')));

    // Дата рождения
    // No min/max on the input: the browser's own range bubble would block «Сохранить»
    // without our localized message (6–100 years is checked below and on the server).
    const bd = v.ppk2Birthdate();
    const years = age(bd);
    const bdError = checkBirthdate(bd);
    rows.push(field('birthdate', t('birthdate.label'), [m("div", {
      className: "Ppk2Date"
    }, m("input", {
      className: "FormControl",
      type: "date",
      name: "ppk2Birthdate",
      value: bd,
      disabled: loading,
      oninput: e => v.ppk2Birthdate(e.target.value)
    })), bdError ? m("div", {
      className: "Ppk2NickStatus Ppk2NickStatus--invalid"
    }, app.translator.trans(bdError[0], bdError[1])) : null, m("label", {
      className: "Ppk2Check"
    }, m("input", {
      type: "checkbox",
      name: "ppk2ShowAgeOnly",
      checked: v.ppk2ShowAgeOnly(),
      disabled: loading,
      onchange: e => v.ppk2ShowAgeOnly(e.target.checked)
    }), m("span", null, years !== null && !bdError ? t('birthdate.age_only', {
      age: t('birthdate.years', {
        count: years
      })
    }) : t('birthdate.age_only_empty')))], visibility(s, 'ppk2BirthdateVisibility', loading), t('birthdate.tip', {
      min: AGE_MIN,
      max: AGE_MAX
    })));

    // О себе
    const bio = v.ppk2Bio();
    rows.push(field('bio', t('bio.label'), [m("textarea", {
      className: "FormControl Ppk2Bio",
      name: "ppk2Bio",
      rows: "3",
      maxlength: BIO_MAX,
      placeholder: t('bio.placeholder'),
      value: bio,
      disabled: loading,
      oninput: e => v.ppk2Bio(e.target.value)
    }), m("div", {
      className: 'Ppk2Counter' + (bio.length >= BIO_MAX ? ' Ppk2Counter--full' : '')
    }, t('bio.counter', {
      count: bio.length,
      max: BIO_MAX
    }))], visibility(s, 'ppk2BioVisibility', loading), t('bio.tip', {
      max: BIO_MAX
    })));

    // Фото
    rows.push(field('photos', t('photos.label'), [this.photoTiles(s, loading), s.crop ? m(PhotoCropper, {
      file: s.crop,
      onsave: blob => this.upload(s, blob),
      oncancel: () => s.crop = null,
      uploading: s.uploading
    }) : null, m("label", {
      className: "Ppk2Check"
    }, m("input", {
      type: "checkbox",
      name: "ppk2ShowPhotos",
      checked: v.ppk2ShowPhotos(),
      disabled: loading,
      onchange: e => v.ppk2ShowPhotos(e.target.checked)
    }), m("span", null, t('photos.show'))), m("label", {
      className: "Ppk2Check"
    }, m("input", {
      type: "checkbox",
      name: "ppk2PhotosForRecords",
      checked: v.ppk2PhotosForRecords(),
      disabled: loading,
      onchange: e => v.ppk2PhotosForRecords(e.target.checked)
    }), m("span", null, t('photos.records')))], null, t('photos.tip', {
      max: MAX_PHOTOS,
      mb: MAX_BYTES / 1024 / 1024
    })));
    return m("div", {
      className: "Ppk2InfoTab"
    }, rows);
  }
  photoTiles(s, loading) {
    const full = s.photos.length >= MAX_PHOTOS;
    return m("div", {
      className: "Ppk2Photos"
    }, s.photos.map(p => m("div", {
      className: "Ppk2Photos-tile",
      key: p.id
    }, m("a", {
      href: p.url,
      target: "_blank",
      rel: "noopener"
    }, m("img", {
      src: p.url,
      alt: "",
      loading: "lazy"
    })), m("button", {
      type: "button",
      className: "Ppk2Photos-delete",
      title: t('photos.delete'),
      "aria-label": t('photos.delete'),
      disabled: loading || s.uploading,
      onclick: () => this.remove(s, p)
    }, m(Icon, {
      name: "fas fa-xmark"
    })))), full ? null : m("label", {
      className: 'Ppk2Photos-add' + (s.uploading || s.crop ? ' disabled' : ''),
      title: t('photos.add_tip', {
        mb: MAX_BYTES / 1024 / 1024
      })
    }, m("input", {
      type: "file",
      accept: "image/png,image/jpeg",
      disabled: loading || s.uploading || !!s.crop,
      onchange: e => this.pick(s, e)
    }), m(Icon, {
      name: "fas fa-plus"
    }), m("span", null, t('photos.add'))));
  }
  pick(s, e) {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (!['image/png', 'image/jpeg'].includes(file.type)) return app.alerts.show({
      type: 'error'
    }, lib('bad_type'));
    if (file.size > MAX_BYTES) return app.alerts.show({
      type: 'error'
    }, lib('too_large', {
      max: MAX_BYTES / 1024 / 1024
    }));
    s.crop = file;
  }
  upload(s, blob) {
    const body = new FormData();
    body.append('photo', blob, 'photo.jpg');
    s.uploading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ppk2/photos',
      serialize: raw => raw,
      body
    }).then(r => {
      s.photos = r.photos || [];
      s.crop = null;
      this.attrs.user.pushAttributes({
        ppk2Photos: s.photos
      });
      app.alerts.show({
        type: 'success'
      }, t('photos.uploaded'));
    }).catch(() => {}).finally(() => {
      s.uploading = false;
      m.redraw();
    });
  }
  remove(s, photo) {
    if (!window.confirm(extractText(t('photos.delete_confirm')))) return;
    s.uploading = true;
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + '/ppk2/photos/' + photo.id
    }).then(r => {
      s.photos = r.photos || [];
      this.attrs.user.pushAttributes({
        ppk2Photos: s.photos
      });
      app.alerts.show({
        type: 'success'
      }, t('photos.deleted'));
    }).catch(() => {}).finally(() => {
      s.uploading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/InfoTab', InfoTab);